import { productPrices } from './product-prices-en.i18n';

export const en = {
  productPrices,
};
